import gql from 'graphql-tag';

const SEND_USER_INVITE_EMAIL = gql`
  mutation sendUserInviteEmail($data: SendUserInviteEmailInput!) {
    sendUserInviteEmail(data: $data)
  }
`;

export default SEND_USER_INVITE_EMAIL;
